import { ROUTES } from 'base/routes/routes';
import { Route, Routes } from 'react-router-dom';

export const wasteGroupingEnvironmentPermitRoutes = ({
  WasteGroupingEnvironmentPermit,
  AddWasteGroupingEnvironmentPermit,
  UpdateWasteGroupingEnvironmentPermit,
}: {
  WasteGroupingEnvironmentPermit: React.ComponentType;
  AddWasteGroupingEnvironmentPermit: React.ComponentType;
  UpdateWasteGroupingEnvironmentPermit: React.ComponentType;
}) => (
  <Routes>
    <Route path="" element={<WasteGroupingEnvironmentPermit />} />
    <Route path={ROUTES.MASTER_DATA.WASTE_GROUPING_ENVIRONMENT_PERMIT.CREATE} element={<AddWasteGroupingEnvironmentPermit />} />
    <Route path={ROUTES.MASTER_DATA.WASTE_GROUPING_ENVIRONMENT_PERMIT.EDIT} element={<UpdateWasteGroupingEnvironmentPermit />} />
  </Routes>
);

